<template>
  <div
    :class="{
      'mx-auto mb-4 w-full max-w-36 px-2 md:mb-0': true,
    }"
  >
    <PtcPicture
      v-if="image.asset && isVisible"
      provider="sanity"
      :src="image.asset._ref"
      :alt="image.altText"
      fit="outside"
      loading="eager"
      :class="{
        'align-middle lg:max-h-full lg:max-w-full': true,
      }"
      :img-attrs="{
        class: { 'max-h-70px w-36 mx-auto': true },
      }"
      :modifiers="{
        crop: image.crop,
        hotspot: image.hotspot,
        w: 200,
        h: 140,
      }"
    />
    <DataStorePersist
      :to-store="image"
      hint="logo-image"
    />
  </div>
</template>

<script lang="ts" setup>
import DataStorePersist from '~/components/Atmos/DataStorePersist/DataStorePersist.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { Logo } from '~/sanity/types';
interface Props extends Logo {
  index: number;
  isVisible: boolean;
}
defineProps<Props>();
</script>

<style></style>
